
export type ForbiddenErrorResponse = {
  error?: string;
  message?: string;
  timestamp?: string;
};
